/* eslint-disable no-underscore-dangle */
import createStore from "./store";
import modules from "./modules";

const store = window.__STORE__ || createStore(modules);
window.__STORE__ = store;

export default store;
